import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "conflict" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M18.367 8.10551C18.2836 7.95023 18.1211 7.85411 17.9449 7.85551H13.9117L16.0173 2.6723L16.0171 2.67216C16.0784 2.52232 16.0618 2.35199 15.9728 2.21666C15.8807 2.08301 15.7295 2.00223 15.5672 2H9.62261C9.4245 2.0014 9.24689 2.12193 9.17253 2.30552L5.60586 11.0834V11.0835C5.54378 11.2339 5.56261 11.4056 5.65594 11.539C5.74313 11.6752 5.89422 11.7571 6.0559 11.7557H11.3838L9.15037 21.4C9.09456 21.6313 9.21454 21.8688 9.43371 21.9611C9.49314 21.9873 9.5576 22.0005 9.62261 22C9.79002 22.0011 9.94585 21.9147 10.0337 21.7722L18.3559 8.60003C18.4509 8.45006 18.4552 8.25963 18.3669 8.1056L18.367 8.10551Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }